<content>
    <form [formGroup]="reutilizaForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-3">
            <label>{{'mantenimientoConfecciones.confeccion.confeccionPallet' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-3">
            <label>{{'mantenimientoConfecciones.confeccion.alias' | translate}}</label>
            <input type="text" formControlName="alias">
        </div>
        <div class="entry-3">
            <label>{{'mantenimientoConfecciones.confeccion.tipoConfeccion' | translate}} *</label>
            <app-filterable-list [itemsList]="tipoConfeccionList" [selectedItem]="reutilizaForm.get('tipoConfeccion')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-short">
            <label>{{'mantenimientoConfecciones.confeccion.nCajas' | translate}} *</label>
            <input type="number" min="1" value="1" formControlName="numCajas">
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)= "createConfeccionReutilizaCajas()">{{'global.insertar' | translate}}</button>
</footer>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast> 